module.exports = __webpack_public_path__ + "d21d8acb2c09d6209d7a0843f4eba204.svg";